import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/rootState'

export default function MqAfterSmall(props) {
  const size = useSelector((state: RootState) => state.mq.size)
  return ['m', 'l'].includes(size) ? props.children : null
}
